/*
 * Small behaviours on top of Prestige's header components.
 * - A popular search chip runs the query in the open search panel instead of leaving the page.
 * - The search controls inside the mobile drawer close the drawer, then open the search panel.
 */
(() => {
  const searchPanel = () => document.querySelector('header-search');

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-nav-search-term]');

    if (chip) {
      const input = searchPanel()?.querySelector('input[name="q"]');

      if (input) {
        event.preventDefault();
        input.value = chip.getAttribute('data-nav-search-term');
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      }

      return;
    }

    const drawerSearch = event.target.closest('[data-nav-open-search]');

    if (drawerSearch) {
      event.preventDefault();
      const sidebar = drawerSearch.closest('header-sidebar');
      const panel = searchPanel();

      Promise.resolve(sidebar?.hide()).then(() => {
        panel?.show();
        panel?.querySelector('input[name="q"]')?.focus();
      });
    }
  });
})();
